<mat-autocomplete autoActiveFirstOption>
  @for (annexModel of data; track annexModel.id) {
    <mat-option [value]="annexModel.id" (onSelectionChange)="emitSelect($event, annexModel)">
      <div class="tiime-option">
        <span class="ellipsis">{{ annexModel.label }}</span>
      </div>
    </mat-option>
  }
</mat-autocomplete>
